import { AnyAction } from '@reduxjs/toolkit';
import {
  DEPT_DATA,
  BLOCK_DATA,
  PRODUCTS_DATA,
  RESTAURANTS_DATA,
  ORDERS_DATA,
  ORDERS_REPORT_DATA,
  ROOM_BILLS,
  SELECTED_RESTAURANT_DATA,
  GLOBAL_CONFIG,
  PUBLIC_RESTAURANTS_DATA,
} from '@constants/actionTypes';

export interface CommonState {
  departments: unknown[];
  blocks: unknown[];
  orders: unknown[];
  restaurants: unknown[];
  selectedRestaurant: Record<string, unknown>;
  products: unknown[];
  ordersReport: unknown[];
  publicRestaurants?: unknown[];
  globalConfig?: unknown;
  roomBills?: unknown;
}

const storedRestaurants =
  typeof localStorage !== 'undefined' && localStorage.getItem('RESTAURANTS_DATA')
    ? JSON.parse(localStorage.getItem('RESTAURANTS_DATA')!)
    : [];

const storedRestaurant =
  typeof localStorage !== 'undefined' && localStorage.getItem('SELECTED_RESTAURANT')
    ? JSON.parse(localStorage.getItem('SELECTED_RESTAURANT')!)
    : {};

const initialState: CommonState = {
  departments: [],
  blocks: [],
  orders: [],
  restaurants: storedRestaurants,
  selectedRestaurant: storedRestaurant,
  products: [],
  ordersReport: [],
};

export default function commonReducers(
  state: CommonState = initialState,
  action: AnyAction
): CommonState {
  switch (action.type) {
    case DEPT_DATA: {
      return {
        ...state,
        departments: action?.payload ?? state.departments,
      };
    }
    case BLOCK_DATA: {
      return {
        ...state,
        blocks: action?.payload ?? state.blocks,
      };
    }
    case PRODUCTS_DATA: {
      return {
        ...state,
        products: action?.payload ?? state.products,
      };
    }
    case RESTAURANTS_DATA: {
      if (typeof localStorage !== 'undefined' && action.payload !== undefined) {
        localStorage.setItem('RESTAURANTS_DATA', JSON.stringify(action.payload));
      }
      return {
        ...state,
        restaurants: action?.payload ?? state.restaurants,
      };
    }
    case PUBLIC_RESTAURANTS_DATA: {
      if (typeof localStorage !== 'undefined' && action.payload !== undefined) {
        localStorage.setItem('PUBLIC_RESTAURANTS_DATA', JSON.stringify(action.payload));
      }
      return {
        ...state,
        publicRestaurants: action?.payload,
      };
    }
    case SELECTED_RESTAURANT_DATA: {
      if (typeof localStorage !== 'undefined' && action.payload !== undefined) {
        localStorage.setItem('SELECTED_RESTAURANT', JSON.stringify(action.payload));
      }
      return {
        ...state,
        selectedRestaurant: action?.payload ?? state.selectedRestaurant,
      };
    }
    case GLOBAL_CONFIG: {
      if (typeof localStorage !== 'undefined' && action.payload !== undefined) {
        localStorage.setItem('GLOBAL_CONFIG', JSON.stringify(action.payload));
      }
      return {
        ...state,
        globalConfig: action?.payload,
      };
    }
    case ORDERS_DATA: {
      return {
        ...state,
        orders: action?.payload ?? state.orders,
      };
    }
    case ORDERS_REPORT_DATA: {
      return {
        ...state,
        ordersReport: action?.payload ?? state.ordersReport,
      };
    }
    case ROOM_BILLS: {
      return {
        ...state,
        roomBills: action?.payload,
      };
    }
    default:
      return state;
  }
}
